import React, { Component } from 'react'
import { connect } from "react-redux";
import { Table } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import IconButton from '@mui/material/IconButton';

import TextField from '@mui/material/TextField';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
   allProgramInclusion,
   addProgramInclusion,
   editProgramInclusion,
   statusProgramInclusion,
   deleteProgramInclusion
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

class programinclusion extends Component {
    
    constructor(props) {
      
        super(props);
           this.state = {
              name: '',
              adddiv:true,
              editdiv:false,
              eid:'',
              edname:'',
              chkbox:false,
              addchkbox:false,
           };      
        
           this.onBackSection = this.onBackSection.bind(this); 
     }
  
    UNSAFE_componentWillMount() {
        this.props.allProgramInclusion();
    }

    addHandleSubmit(event) {
        event.preventDefault();
        this.props.addProgramInclusion(this.state.name);
        this.setState({ 
                       name:'',
                    });
     }
  
     deletePgInclusion(id){
        if(window.confirm('Are you sure to delete this ProgramInclusion?')){          
           this.props.deleteProgramInclusion(id);           
        }
     }
  
     editPgInclusion(rawdata){
        
       
        this.setState({
           eid:rawdata.apiID,
           edname:rawdata.api_name,    
           adddiv:false,
           editdiv:true
        });
     }
  
     editHandleSubmit(event) {
        event.preventDefault();
        this.props.editProgramInclusion(this.state.edname,this.state.eid);      
     }
     
    statusPgInclusion(id,status){
        this.props.statusProgramInclusion(id,status);       
    }
  
    onBackSection() {
		this.setState({ adddiv:true,
         editdiv:false });
	}

    render() {
        const { match, programinclusionlists, loading } = this.props;
      
        return (
            <div className="saas-dashboard">
                <Helmet>
                <title>Program Inclusion | {AppConfig.appTitle}</title>
                <meta name="description" content="Reactify Sass Dashboard" />
                </Helmet>
                <PageTitleBar title={<IntlMessages id="sidebar.programinclusionheading" />} match={match} />
                <div className="row">
               <div className="col-sm-12 col-lg-8">
                  <RctCollapsibleCard heading="List">
                     <div className="table-responsive">
                           <Table hover bordered striped>
                              <thead>
                                 <tr className="bg-primary text-white">
                                    <th>Sl.No</th>
                                    <th>Name</th>
                                    <th>Action</th>
                                 </tr>
                              </thead>
                              <tbody>                              
                              {programinclusionlists.map((pgincl,idx) => (
                                 <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>{pgincl.api_name}</td>
                                    <td>
                                       {pgincl.api_status==1 ? (
                                          <a herf="" onClick={ ()=>this.statusPgInclusion(pgincl.apiID,0)}><span className="badge badge-info" >Active</span></a> 
                                       ) : (
                                          <a herf="" onClick={ ()=>this.statusPgInclusion(pgincl.apiID,1)}><span className="badge badge-danger" >Inactive</span></a> 
                                       )}
                                       <IconButton className="text-info" aria-label="edit" onClick={ ()=>this.editPgInclusion(pgincl)}><EditOutlinedIcon/></IconButton>
                                       <IconButton className="text-danger" aria-label="Delete" onClick={ ()=>this.deletePgInclusion(pgincl.apiID)}><DeleteOutlineOutlinedIcon/></IconButton> 
                                       </td>
                                 </tr>
                              ))}
                                                      
                              </tbody>
                           </Table>
                     </div>
                  </RctCollapsibleCard>
               </div>  
               {this.state.adddiv && 
               <div className="col-sm-6 col-lg-4">
                  <RctCollapsibleCard heading="Add Program Inclusion">
                     <form autoComplete="off" onSubmit={(e)=>this.addHandleSubmit(e)}>
                        <div className="row">
                           <div className="col-sm-12 col-lg-6 col-xl-12">
                              <div className="form-group">
                                 <TextField id="name" fullWidth label="Name" required  value={this.state.name} onChange={evt => this.setState({name: evt.target.value})}/>
                              </div>                          
                              
                              <div className="form-group">
                                 <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                              
                              </div>
                           </div>   
                        </div>   
                     </form> 
                  </RctCollapsibleCard>  
               </div>
               }

               {this.state.editdiv && 
               <div className="col-sm-6 col-lg-4">                   
                  <RctCollapsibleCard heading="Edit Program Inclusion">                     
                     <form autoComplete="off" onSubmit={this.editHandleSubmit}>
                        <div className="row">
                           <div className="col-sm-12 col-lg-6 col-xl-12">
                              <div className="form-group">
                                 <TextField id="name" fullWidth label="Name" required  value={this.state.edname} onChange={evt => this.setState({edname: evt.target.value})}/>
                              </div>
                                                            
                              <div className="form-group">
                                 <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                 <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />
                              
                              </div>
                           </div>   
                        </div>   
                     </form> 
                  </RctCollapsibleCard>  
               </div>
               }
             </div>
            </div>        
        )

    }

}

const mapStateToProps = ({ programinclusion }) => {
	const { programinclusionlists, loading } = programinclusion;
	return { programinclusionlists, loading };
}

export default connect(mapStateToProps, {
   allProgramInclusion,
   addProgramInclusion,
   editProgramInclusion,
   statusProgramInclusion,
   deleteProgramInclusion
})(programinclusion); 